import { request } from './helpers/request'
import { GENERIC_RECOVERY_CODES_ERROR_CODE } from '../constants/error.codes'

export const registerRecoveryOtps = () =>
  request({
    url: '/users/mfa/otp',
  }).then((response) => {
    if (response.status === 200) {
      return Promise.resolve(response.data)
    } else if (response.status === 403) {
      return Promise.reject(new Error(response.data.code))
    } else {
      return Promise.reject(new Error(GENERIC_RECOVERY_CODES_ERROR_CODE))
    }
  })
